/**
 * Seller state for the invoice editor (tour bug B-AC-05, 2026-10-07).
 * The seller is the tenant's company profile, not a hard-coded Haryana. 06 is
 * kept only as the fallback when the profile carries no stateCode.
 */
export const FALLBACK_SELLER_STATE_CODE = '06';

export const INDIAN_STATES = [
  { code: '01', name: 'Jammu & Kashmir' },
  { code: '02', name: 'Himachal Pradesh' },
  { code: '03', name: 'Punjab' },
  { code: '04', name: 'Chandigarh' },
  { code: '05', name: 'Uttarakhand' },
  { code: '06', name: 'Haryana' },
  { code: '07', name: 'Delhi' },
  { code: '08', name: 'Rajasthan' },
  { code: '09', name: 'Uttar Pradesh' },
  { code: '10', name: 'Bihar' },
  { code: '11', name: 'Sikkim' },
  { code: '12', name: 'Arunachal Pradesh' },
  { code: '13', name: 'Nagaland' },
  { code: '14', name: 'Manipur' },
  { code: '15', name: 'Mizoram' },
  { code: '16', name: 'Tripura' },
  { code: '17', name: 'Meghalaya' },
  { code: '18', name: 'Assam' },
  { code: '19', name: 'West Bengal' },
  { code: '20', name: 'Jharkhand' },
  { code: '21', name: 'Odisha' },
  { code: '22', name: 'Chhattisgarh' },
  { code: '23', name: 'Madhya Pradesh' },
  { code: '24', name: 'Gujarat' },
  { code: '25', name: 'Daman & Diu' },
  { code: '26', name: 'Dadra & Nagar Haveli' },
  { code: '27', name: 'Maharashtra' },
  { code: '29', name: 'Karnataka' },
  { code: '30', name: 'Goa' },
  { code: '31', name: 'Lakshadweep' },
  { code: '32', name: 'Kerala' },
  { code: '33', name: 'Tamil Nadu' },
  { code: '34', name: 'Puducherry' },
  { code: '35', name: 'Andaman & Nicobar' },
  { code: '36', name: 'Telangana' },
  { code: '37', name: 'Andhra Pradesh' },
];

export function sellerStateCode(profile: { stateCode?: string | null } | null | undefined): string {
  const code = (profile?.stateCode ?? '').trim();
  return code || FALLBACK_SELLER_STATE_CODE;
}

export function isIntraStateSupply(buyerState: string, sellerState: string): boolean {
  return buyerState === sellerState;
}

export function supplyHint(buyerState: string, sellerState: string): string {
  if (!isIntraStateSupply(buyerState, sellerState)) return 'Inter-state supply — IGST applies';
  const name = INDIAN_STATES.find((s) => s.code === sellerState)?.name ?? sellerState;
  return `Intra-state supply (same state as seller: ${name}) — CGST + SGST applies`;
}
